(function(){
  const MENU = document.getElementById("menu-drawer");
  const TOPBAR = document.getElementById("WPS__topbar");
  if(!MENU) return;

  const OPEN_HEIGHT = 155;
  const CLOSED_HEIGHT = 0;
  let lastOffset = null;

  function isTopbarVisible(){
    if(!TOPBAR) return false;
    const rect = TOPBAR.getBoundingClientRect();
    const style = window.getComputedStyle(TOPBAR);
    const visible = style.display !== "none" && style.visibility !== "hidden" && style.opacity !== "0" && rect.height > 5;
    return visible;
  }

  function updateOffset(immediate=false){
    const visible = isTopbarVisible();
    const offset = visible ? OPEN_HEIGHT : CLOSED_HEIGHT;
    if(offset !== lastOffset){
      lastOffset = offset;
      MENU.style.transition = immediate ? "none" : "top 0.35s ease, height 0.35s ease";
      MENU.style.top = offset + "px";
      MENU.style.height = `calc(100% - ${offset}px)`;
    }
  }

  function loop(){
    updateOffset();
    requestAnimationFrame(loop);
  }

  document.addEventListener("DOMContentLoaded", () => {
    updateOffset(true);
    requestAnimationFrame(loop);
  });
})();
